"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardReadingPaneOption')(function discardReadingPaneOption(state) {
    var optionState = state.optionState;
    optionState.readingPanePosition = null;
    optionState.nextSelection = null;
    optionState.loadMessageOnLogOn = null;
}));
//# sourceMappingURL=discardReadingPaneOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reading-pane-option/lib/actions/discardReadingPaneOption.js
// module id = 5122
// module chunks = 2